import { FREE, OWN, SHIPPING } from '../../util/constants';
import { CHECKOUT_STEPS } from '../../util/enums';
import {
  listingShips,
  listingShipsFreeByOwnShipping,
  listingShipsWithTutulistLabel,
} from '../../util/listingDelivery';

const CHECKOUT_STEP_MAP = {
  [CHECKOUT_STEPS.SHIPPING_DETAILS]: {
    key: CHECKOUT_STEPS.SHIPPING_DETAILS,
    labelKey: 'CheckoutPage.step.shippingAddress',
  },
  [CHECKOUT_STEPS.CARRIERS]: {
    key: CHECKOUT_STEPS.CARRIERS,
    labelKey: 'CheckoutPage.step.carriers',
  },
  [CHECKOUT_STEPS.PAYMENT_DETAILS]: {
    key: CHECKOUT_STEPS.PAYMENT_DETAILS,
    labelKey: 'CheckoutPage.step.payment',
  },
};

export const getCheckoutStepConfig = ({
  isShippingRequired,
  orderDeliveryMethod,
  sellerShippingType,
  authorShippingPreference,
  isShippoEnabled,
  listing,
}) => {
  const hasDeliveryMethod = typeof orderDeliveryMethod === 'string' && orderDeliveryMethod.length > 0;
  const sellerHasShippingConfigured = [SHIPPING, FREE].includes(sellerShippingType);
  // The listing's own delivery options decide whether it ships, and a Tutulist label on it wins
  // over the seller's account settings (which can disagree with older listings)
  const shipsByListing = listingShips(listing);
  const requiresShippingAddress =
    typeof isShippingRequired === 'boolean'
      ? isShippingRequired
      : hasDeliveryMethod
      ? orderDeliveryMethod === SHIPPING
      : shipsByListing || sellerHasShippingConfigured;
  // 'tutulist' and 'freeShipping' say how the listing ships; plain 'shipping' is also saved on
  // Tutulist-label sellers' listings, so it goes by the seller's account
  const sellerUsesOwnShipping = listingShipsWithTutulistLabel(listing)
    ? false
    : listingShipsFreeByOwnShipping(listing) || authorShippingPreference === OWN;
  const requiresCarrierSelection =
    requiresShippingAddress && !sellerUsesOwnShipping && Boolean(isShippoEnabled);

  const stepKeys = [
    CHECKOUT_STEPS.SHIPPING_DETAILS,
    ...(requiresCarrierSelection ? [CHECKOUT_STEPS.CARRIERS] : []),
    CHECKOUT_STEPS.PAYMENT_DETAILS,
  ];

  return {
    requiresShippingAddress,
    requiresCarrierSelection,
    steps: stepKeys.map(key => CHECKOUT_STEP_MAP[key]),
  };
};

export const findCheckoutStepIndex = (steps, stepKey) =>
  steps.findIndex(step => step.key === stepKey);

export const getPreviousCheckoutStep = (steps, stepKey) => {
  const currentIndex = findCheckoutStepIndex(steps, stepKey);
  return currentIndex > 0 ? steps[currentIndex - 1].key : null;
};

export const isValidCheckoutStep = (steps, stepKey) =>
  findCheckoutStepIndex(steps, stepKey) >= 0;
